import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { EmpathySection } from './components/EmpathySection';
import { PromiseSection } from './components/PromiseSection';
import { ModulesSection } from './components/ModulesSection';
import { ForYouSection } from './components/ForYouSection';
import { BonusesSection } from './components/BonusesSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { PricingSection } from './components/PricingSection';
import { FaqSection } from './components/FaqSection';
import { Footer } from './components/Footer';
import { trackPageView } from './lib/pixel';
export function App() {
  useEffect(() => {
    trackPageView();
  }, []);
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <EmpathySection data-id="element-4" />
        <PromiseSection data-id="element-5" />
        <ModulesSection data-id="element-6" />
        <ForYouSection data-id="element-7" />
        <BonusesSection data-id="element-8" />
        <GuaranteeSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <FaqSection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}